import { ShieldCheck } from "lucide-react";

import { StoreButtons } from "@/components/landing/StoreButtons";
import type { Locale } from "@/i18n/locales";
import { cn } from "@/lib/utils";

type DownloadCtaProps = {
  locale: Locale;
  title: string;
  text: string;
  className?: string;
};

export function DownloadCta({ locale, title, text, className }: DownloadCtaProps) {
  return (
    <section className={cn("pb-24", className)}>
      <div className="mx-auto max-w-3xl px-5">
        <div className="rounded-3xl bg-[#1a3a5c] p-10 text-center text-white">
          <ShieldCheck className="mx-auto mb-4 h-10 w-10 text-primary" />
          <h2 className="mb-3 font-heading text-2xl font-bold md:text-3xl">
            {title}
          </h2>
          <p className="mb-6 text-base leading-relaxed text-white/70">{text}</p>
          <StoreButtons locale={locale} className="justify-center" />
        </div>
      </div>
    </section>
  );
}
